import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginModule } from './login/login.module';
import { RecoverPassword } from './password/recover-password.component';
import { TruckerEnrollmentComponent } from './trucker-enrollment/trucker-enrollment.component';
import { PasswordValidationIssuesComponent } from '../shared/custom-components/password-validation-issues/password-validation-issues.component';
import { AuthLogoComponent } from '../shared/modules/logo/auth-logo/auth-logo.component';


@NgModule({ declarations: [
        TruckerEnrollmentComponent,
        RecoverPassword,
    ], imports: [ReactiveFormsModule,
        RouterModule,
        AuthRoutingModule,
        CommonModule,
        SharedModule,
        LoginModule,
        PasswordValidationIssuesComponent,
        AuthLogoComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class AuthModule { }
